import { render } from "./FieldBasicInfo.vue?vue&type=template&id=1394b50b"
import script from "./FieldBasicInfo.vue?vue&type=script&lang=js"
export * from "./FieldBasicInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__